import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

class UserMenu {
  /**
   * Base state
   */
  _state = {
    open: false,
    scrollTop: 0,
  };

  static options = {
    timeout: 450,
  };

  constructor(options = {}) {
    this._options = { ...options };
    this._elements = Array.prototype.slice.call(document.querySelectorAll('.side-toggle'), 0);
    this._target = document.querySelector('#side_menu');
    this._main = document.querySelector('#main');
    this._body = document.querySelector('#body');
    this._html = document.documentElement;
    if (this._body.getAttribute('data-edit') === 'true') {
      return;
    }
    this._navigation = this._target.querySelector('.navigation-list');
    this._backButton = this._target.querySelector('.side-menu__back__button');
    this._closeButtons = [...document.querySelectorAll('.close-sidemenu')];
    this._contactButtons = [...document.querySelectorAll('.contact-button')];

    this._closeButtons.forEach((element) => {
      element.onclick = () => {
        this.closeSideMenu(element);
      };
    });

    this._contactButtons.forEach((element) => {
      if (element.getAttribute('href').indexOf('#') > -1) {
        element.classList.add('anchor-link');
      } else {
        element.classList.remove('anchor-link');
      }
    });

    this._elements.forEach((element) => {
      element.onclick = () => {
        this._state.open = !this._state.open;
        if (!this._state.open) {
          // closing menu
          this.closeSideMenu(element);
        } else {
          // opening menu
          this.togglemenu(this, element);
        }
      };
    });
  }
  _enableScroll() {
    this._body.scrollTop = this._html.scrollTop = this._state.scrollTop;
    this._state.scrollTop = 0;
    enableBodyScroll(this._body);
    this._html.setAttribute('data-overflow', true);
  }

  _disableScroll() {
    this._state.scrollTop = this._body.scrollTop || this._html.scrollTop;
    disableBodyScroll(this._body);
    this._html.setAttribute('data-overflow', false);
  }

  closeSideMenu(element) {
    this._state.open = false;
    this.togglemenu(this, element);
  }

  togglemenu(t, el) {
    el.setAttribute('aria-expanded', t._state.open);
    t._target.setAttribute('data-open', t._state.open);
    t._main.setAttribute('data-side-open', t._state.open);
    clearAllBodyScrollLocks();
    if (t._state.open) {
      this._disableScroll();
    } else {
      this._enableScroll();
    }
  }
}

export default UserMenu;
